import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { EnumDropdownItemVariant } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { analyticsExportFormats } from 'entities/Analytics'
import { type IExportAnalyticsModalView } from 'widgets/ExportAnalyticsModal/store/exportAnalyticsModalStore'
import styles from './styles.module.scss'

type IExportAnalyticsModalContentProps = {
  store: IExportAnalyticsModalView
}

export const ExportAnalyticsModalContent: FC<IExportAnalyticsModalContentProps> = observer(
  ({ store: { format, setFormat } }) => {
    return (
      <div className={styles.content}>
        <SelectField
          labelText={'Format'}
          items={analyticsExportFormats.map((format) => ({
            id: format,
            label: format.toUpperCase(),
            variant: EnumDropdownItemVariant.CheckedRight,
          }))}
          selectProps={{
            variant: 'stroke',
            textFieldPlaceholderProps: {
              size: 'medium',
            },
          }}
          value={format}
          setValue={setFormat}
        />
      </div>
    )
  }
)
